import { api } from "../../api";
import { API_NOTIFICATION_CONSTANT } from "./api-notification.constant";
import {
  SendInvitationRequest,
  TestMessageRequest,
  NotificationResponse,
} from "./api-notification.type";

export const notificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendInvitation: builder.mutation<NotificationResponse, SendInvitationRequest>({
      query: (data) => ({
        url: API_NOTIFICATION_CONSTANT.sendInvitation,
        method: "post",
        body: data,
      }),
    }),
    sendTestMessage: builder.mutation<NotificationResponse, TestMessageRequest>({
      query: (data) => ({
        url: API_NOTIFICATION_CONSTANT.testMessage,
        method: "post",
        body: data,
      }),
    }),
    sendExpiryNotification: builder.mutation<NotificationResponse, { subscriptionId: string }>({
      query: ({ subscriptionId }) => ({
        url: `${API_NOTIFICATION_CONSTANT.expiryNotification}/${subscriptionId}`,
        method: "post",
      }),
    }),
    checkExpiringSubscriptions: builder.mutation<NotificationResponse, void>({
      query: () => ({
        url: API_NOTIFICATION_CONSTANT.checkExpiring,
        method: "post",
      }),
    }),
  }),
});

export const {
  useSendInvitationMutation,
  useSendTestMessageMutation,
  useSendExpiryNotificationMutation,
  useCheckExpiringSubscriptionsMutation,
} = notificationApi;
